export const counts = [
    {
        "count": 38,
        "lat": -12.378451,
        "lng": 130.877014
    },
    {
        "count": 19,
        "lat": -12.400091,
        "lng": 130.913672
    },
    {
        "count": 6,
        "lat": -12.410444,
        "lng": 130.856124
    },
    {
        "count": 13,
        "lat": -12.799278,
        "lng": 131.131697
    },
    {
        "count": 1,
        "lat": -14.460879,
        "lng": 132.280002
    },
    {
        "count": 30,
        "lat": -12.487233,
        "lng": 130.97263700000002
    },
    {
        "count": 1,
        "lat": -12.480066,
        "lng": 130.984006
    },
    {
        "count": 25,
        "lat": -12.492269,
        "lng": 130.990891
    },
    {
        "count": 6,
        "lat": -12.48138,
        "lng": 131.029173
    },
    {
        "count": 9,
        "lat": -12.525546,
        "lng": 131.103025
    },
    {
        "count": 1,
        "lat": -12.460094,
        "lng": 130.842663
    },
    {
        "count": 1,
        "lat": -12.717562,
        "lng": 130.351316
    },
    {
        "count": 1,
        "lat": -13.038663,
        "lng": 131.072091
    },
    {
        "count": 1,
        "lat": -16.81839,
        "lng": 137.14706999999999
    },
    {
        "count": 5,
        "lat": -12.378064,
        "lng": 130.871791
    },
    {
        "count": 1,
        "lat": -12.18421,
        "lng": 136.783889
    },
    {
        "count": 42,
        "lat": -23.785682,
        "lng": 150.926796
    },
    {
        "count": 13,
        "lat": -23.651894,
        "lng": 150.641144
    },
    {
        "count": 544,
        "lat": -23.388939,
        "lng": 150.50286699999998
    },
    {
        "count": 992,
        "lat": -23.362809,
        "lng": 150.52269099999998
    },
    {
        "count": 547,
        "lat": -24.325475,
        "lng": 149.782526
    },
    {
        "count": 866,
        "lat": -23.114684,
        "lng": 150.696731
    },
    {
        "count": 3,
        "lat": -23.119953,
        "lng": 150.462544
    },
    {
        "count": 4,
        "lat": -22.743208,
        "lng": 149.313523
    },
    {
        "count": 5,
        "lat": -22.592329,
        "lng": 149.635224
    },
    {
        "count": 8,
        "lat": -21.868843,
        "lng": 149.143033
    },
    {
        "count": 243,
        "lat": -23.257223,
        "lng": 150.82635
    },
    {
        "count": 56,
        "lat": -23.252534,
        "lng": 150.47622900000002
    },
    {
        "count": 543,
        "lat": -21.454914000000002,
        "lng": 149.28956200000002
    },
    {
        "count": 76,
        "lat": -21.704347,
        "lng": 149.356583
    },
    {
        "count": 26,
        "lat": -21.910044,
        "lng": 149.416599
    },
    {
        "count": 3911,
        "lat": -21.164465,
        "lng": 149.09960900000002
    },
    {
        "count": 473,
        "lat": -20.904510000000002,
        "lng": 148.99513000000002
    },
    {
        "count": 34,
        "lat": -21.538291,
        "lng": 148.075393
    },
    {
        "count": 4,
        "lat": -21.355672,
        "lng": 148.115193
    },
    {
        "count": 62,
        "lat": -22.588153,
        "lng": 148.348719
    },
    {
        "count": 5,
        "lat": -22.640498,
        "lng": 148.916434
    },
    {
        "count": 312,
        "lat": -21.043768,
        "lng": 149.15747
    },
    {
        "count": 365,
        "lat": -21.188625,
        "lng": 149.03059
    },
    {
        "count": 251,
        "lat": -21.116487,
        "lng": 148.890812
    },
    {
        "count": 131,
        "lat": -21.158348,
        "lng": 148.81380900000002
    },
    {
        "count": 29,
        "lat": -21.142454999999998,
        "lng": 148.63221000000001
    },
    {
        "count": 22,
        "lat": -21.167011,
        "lng": 148.50552
    },
    {
        "count": 78,
        "lat": -20.897517999999998,
        "lng": 148.771151
    },
    {
        "count": 107,
        "lat": -20.705298000000003,
        "lng": 148.59576299999998
    },
    {
        "count": 602,
        "lat": -20.584521,
        "lng": 148.420002
    },
    {
        "count": 449,
        "lat": -20.267869,
        "lng": 148.71622299999999
    },
    {
        "count": 102,
        "lat": -20.553361,
        "lng": 147.845464
    },
    {
        "count": 438,
        "lat": -20.382548,
        "lng": 147.885867
    },
    {
        "count": 214,
        "lat": -19.669608,
        "lng": 147.44651100000002
    },
    {
        "count": 526,
        "lat": -19.546861,
        "lng": 147.443697
    },
    {
        "count": 63,
        "lat": -19.554272,
        "lng": 147.353705
    },
    {
        "count": 70,
        "lat": -19.531139000000003,
        "lng": 147.213564
    },
    {
        "count": 696,
        "lat": -19.245827,
        "lng": 146.795727
    },
    {
        "count": 558,
        "lat": -19.316209,
        "lng": 146.82358
    },
    {
        "count": 977,
        "lat": -19.274924,
        "lng": 146.776217
    },
    {
        "count": 1897,
        "lat": -19.297714000000003,
        "lng": 146.764341
    },
    {
        "count": 707,
        "lat": -19.330397,
        "lng": 146.727724
    },
    {
        "count": 443,
        "lat": -19.424915,
        "lng": 146.947198
    },
    {
        "count": 934,
        "lat": -19.326610000000002,
        "lng": 146.59971000000002
    },
    {
        "count": 1043,
        "lat": -19.202291,
        "lng": 146.659747
    },
    {
        "count": 182,
        "lat": -19.151037,
        "lng": 146.86423
    },
    {
        "count": 211,
        "lat": -20.082915,
        "lng": 146.249367
    },
    {
        "count": 40,
        "lat": -21.50903,
        "lng": 142.69317
    },
    {
        "count": 76,
        "lat": -18.265652,
        "lng": 146.027929
    },
    {
        "count": 341,
        "lat": -18.474994,
        "lng": 145.88579099999998
    },
    {
        "count": 267,
        "lat": -17.830091,
        "lng": 146.09996
    },
    {
        "count": 228,
        "lat": -18.119359,
        "lng": 145.91311399999998
    },
    {
        "count": 60,
        "lat": -17.786658,
        "lng": 146.021722
    },
    {
        "count": 50,
        "lat": -17.719188,
        "lng": 146.02696799999998
    },
    {
        "count": 73,
        "lat": -17.566620999999998,
        "lng": 146.035946
    },
    {
        "count": 35,
        "lat": -17.596413000000002,
        "lng": 145.971405
    },
    {
        "count": 538,
        "lat": -17.564220000000002,
        "lng": 145.996277
    },
    {
        "count": 108,
        "lat": -17.344418,
        "lng": 145.924815
    },
    {
        "count": 265,
        "lat": -17.152995,
        "lng": 145.743914
    },
    {
        "count": 616,
        "lat": -16.962826999999997,
        "lng": 145.73042900000002
    },
    {
        "count": 448,
        "lat": -17.004072,
        "lng": 145.73883500000002
    },
    {
        "count": 1935,
        "lat": -16.883938,
        "lng": 145.746732
    },
    {
        "count": 358,
        "lat": -17.608738,
        "lng": 143.185168
    },
    {
        "count": 101,
        "lat": -17.231966,
        "lng": 145.62332
    },
    {
        "count": 357,
        "lat": -16.372831,
        "lng": 145.384849
    },
    {
        "count": 119,
        "lat": -12.662367999999999,
        "lng": 141.849076
    },
    {
        "count": 8,
        "lat": -10.120146,
        "lng": 142.139423
    },
    {
        "count": 1,
        "lat": -10.851692,
        "lng": 142.42701399999999
    },
    {
        "count": 223,
        "lat": -16.535286,
        "lng": 145.467604
    },
    {
        "count": 613,
        "lat": -16.838291,
        "lng": 145.708683
    },
    {
        "count": 677,
        "lat": -16.765776000000002,
        "lng": 145.668652
    },
    {
        "count": 263,
        "lat": -17.109907999999997,
        "lng": 145.30199299999998
    },
    {
        "count": 188,
        "lat": -16.824388,
        "lng": 145.509799
    },
    {
        "count": 72,
        "lat": -17.185835,
        "lng": 145.463033
    },
    {
        "count": 233,
        "lat": -17.268273,
        "lng": 145.47457
    },
    {
        "count": 99,
        "lat": -17.219314999999998,
        "lng": 145.696889
    },
    {
        "count": 140,
        "lat": -17.363155,
        "lng": 145.69377
    },
    {
        "count": 42,
        "lat": -17.542146,
        "lng": 145.605722
    },
    {
        "count": 76,
        "lat": -17.384930999999998,
        "lng": 145.386636
    },
    {
        "count": 117,
        "lat": -17.499336,
        "lng": 145.491052
    },
    {
        "count": 30,
        "lat": -17.281509,
        "lng": 141.62584099999998
    },
    {
        "count": 26,
        "lat": -17.483843,
        "lng": 140.839772
    },
    {
        "count": 107,
        "lat": -16.013552,
        "lng": 145.263051
    },
    {
        "count": 43,
        "lat": -22.158615,
        "lng": 113.92033300000001
    },
    {
        "count": 7,
        "lat": -22.095,
        "lng": 115.85528000000001
    },
    {
        "count": 27,
        "lat": -20.661726,
        "lng": 116.707075
    },
    {
        "count": 259,
        "lat": -20.663163,
        "lng": 117.09337099999999
    },
    {
        "count": 1,
        "lat": -21.654285,
        "lng": 116.129747
    },
    {
        "count": 2,
        "lat": -20.77542,
        "lng": 117.146619
    },
    {
        "count": 9,
        "lat": -20.67833,
        "lng": 117.18861000000001
    },
    {
        "count": 32,
        "lat": -20.786363,
        "lng": 118.598409
    },
    {
        "count": 72,
        "lat": -20.395561999999998,
        "lng": 118.572647
    },
    {
        "count": 35,
        "lat": -17.914172,
        "lng": 122.247317
    },
    {
        "count": 28,
        "lat": -17.950181,
        "lng": 122.196423
    },
    {
        "count": 9,
        "lat": -17.986747,
        "lng": 124.178459
    },
    {
        "count": 1,
        "lat": -14.910744000000001,
        "lng": 126.66623899999999
    },
    {
        "count": 17,
        "lat": -15.174207999999998,
        "lng": 128.550721
    }
];